import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Params,
} from "@angular/router";
import { environment } from "environments/environment";
import { JwtAuthService } from "../../auth/services/jwt-auth.service";
import { IdentityAuthService } from "../services/identity-auth.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private jwtAuth: JwtAuthService,
    private identityAuthService: IdentityAuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!environment.winAuth) {
      let isLoggedIn = this.jwtAuth.isLoggedIn();

      if (environment.enableSSO) {
        isLoggedIn = this.jwtAuth.isLoggedIn() || this.identityAuthService.isLoggedIn();
      }

      let logovanjeSaServisa = this.proveriAutomatskoLogovanje(route.queryParams);

      if (isLoggedIn) {
        if (this.imaPravoPristupa(route)) {
          if (logovanjeSaServisa) {
            sessionStorage.removeItem('logovanjeSaServisa');
            this.router.navigate(['/recnik-poruka/nova-poruka']);
          }
          return true;
        }
        else {
          this.router.navigate(['/neautorizovanPristup']);
          return false;
        }
      } else {
        this.router.navigate(["session/signin"]);
        return false;
      }
    }
    return true;
  }

  imaPravoPristupa(route: ActivatedRouteSnapshot): boolean {
    if (!!!route.data || !!!route.data.authData) {
      return true;
    }
    else {
      return this.jwtAuth.hasClaim(route.data.authData);
    }
  }

  private proveriAutomatskoLogovanje(queryParams: Params): boolean {
    let logovanjeSaServisa = !!queryParams.autoLogin && queryParams.autoLogin == "true";
      if (logovanjeSaServisa) {
        sessionStorage.setItem('logovanjeSaServisa', "true");
      }

    return logovanjeSaServisa;
  }
}
